/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
   export class DateRangeService {
      public doesDateRangePass(date: Date, dateRange: Wars.Domain.Model.Codes.Enums.DateRange) {
          switch (dateRange) {
              case Wars.Domain.Model.Codes.Enums.DateRange.AnyDate:
                  return date != null;
              case Wars.Domain.Model.Codes.Enums.DateRange.FutureDate:
                  return date.setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0) ;
              case Wars.Domain.Model.Codes.Enums.DateRange.PresentDate:
                  return date.setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0);
              case Wars.Domain.Model.Codes.Enums.DateRange.PreviousDate:
                  return date.setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0);
              default:
                  return false;
          }
       }

       public dateRangeFailureText(dateRange: Wars.Domain.Model.Codes.Enums.DateRange) {
           switch (dateRange) {
               case Wars.Domain.Model.Codes.Enums.DateRange.AnyDate:
                   return "must be a date.";
               case Wars.Domain.Model.Codes.Enums.DateRange.FutureDate:
                   return "must be the current or a future date.";
           case Wars.Domain.Model.Codes.Enums.DateRange.PresentDate:
                   return "must be the current date.";
           case Wars.Domain.Model.Codes.Enums.DateRange.PreviousDate:
                   return "must be the current or a previous date.";
           default:
               return "";
           }
       }
   } 
}

warsApp.registerService('DateRangeService',[]);